import { render } from "./RoutingPanel.vue?vue&type=template&id=3db8af32&scoped=true"
import script from "./RoutingPanel.vue?vue&type=script&lang=js"
export * from "./RoutingPanel.vue?vue&type=script&lang=js"

import "./RoutingPanel.vue?vue&type=style&index=0&id=3db8af32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db8af32"]])

export default __exports__